import { styled } from "@mui/material/styles";
import {
  Box,
  Card,
  TableContainer,
  TableRow,
  TableCell,
  Paper
} from "@mui/material";

export const softColors = {
  primary: "#1976d2",
  background: "#FFFFFF",
  border: "#E5E7EB",
  hover: "#F3F4F6",
  success: "#388e3c",
  successBg: "#e8f5e9",
  successBorder: "#a5d6a7",
  error: "#d32f2f",
  errorBg: "#ffebee",
  errorBorder: "#ef9a9a",
  warning: "#f57c00",
  warningBg: "#fff4e5",
  warningBorder: "#ffcc80",
  info: "#1976d2",
  infoBg: "#e3f2fd",
  infoBorder: "#90caf9",
  final: "#d3c2eeff",        
  finalBg: "#5e408aff",       
  finalBorder: "#885ccaff",
  retainer: "#9C27B0",
  retainerBg: "#F3E5F5",
  retainerBorder: "#CE93D8",
  text: "#374151",
  secondaryText: "#6B7280",
};

export const StyledContainer = styled(Box)(() => ({
  width: "100%",
  backgroundColor: softColors.background,
  padding: "20px",
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: '2400px',
  margin: '0 auto',
  borderRadius: theme.spacing(2),
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
  border: `1px solid ${softColors.border}`,
  backgroundColor: "#ffffff",
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  "& .MuiTable-root": {
    borderCollapse: "separate",
    borderSpacing: "0",
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#fafbfc",
  },
  "&:hover": {
    backgroundColor: "#f5f7fa",
    transform: "translateY(-2px)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    cursor: "pointer"
  },
  transition: "all 0.3s ease",
  position: "relative"
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(2),
  borderBottom: `1px solid ${softColors.border}`,
  color: softColors.text,
  fontSize: "0.875rem",
  transition: "all 0.3s ease"
}));

export const StyledTableHeadCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#f0f7ff",
  color: "#1976d2",
  fontWeight: 600,
  padding: theme.spacing(2),
  borderBottom: `2px solid #1976d2`,
  fontSize: "0.875rem",
}));

export const StyledDetailCard = styled(Card)(({ theme }) => ({
  backgroundColor: "#ffffff",
  borderRadius: theme.spacing(1.5),
  border: `1px solid ${softColors.border}`,
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
}));

export const StyledNoResultsOverlay = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  color: 'text.secondary',
  fontSize: '1.1rem',
  padding: theme.spacing(6, 0)
}));

export const StyledMobileCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.spacing(2),
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 6px 16px rgba(0,0,0,0.12)'
  }
}));

export const getStatusChipStyles = (status) => {
  let backgroundColor, color, borderColor;

  const normalizedStatus = (status || '').toString().trim().toLowerCase();

  switch (normalizedStatus) {
    case "סופית":
    case "final":
      backgroundColor = softColors.final;
      color = softColors.finalBg;
      borderColor = softColors.finalBg;
      break;
    case "אושר ונקלט":
    case "approved":
      backgroundColor = softColors.successBg;
      color = softColors.success;
      borderColor = softColors.successBorder;
      break;
    case "נדחה":
    case "rejected":
      backgroundColor = softColors.errorBg;
      color = softColors.error;
      borderColor = softColors.errorBorder;
      break;
    case "ממתין לאישור":
    case "PENDING_APPROVAL":
    case "אושר, טרם נקלט בפריוריטי":
    case "ממתין ליצירה בפריוריטי":
    case "ממתין לקבלת סחורה":
      backgroundColor = softColors.warningBg;
      color = softColors.warning;
      borderColor = softColors.warningBorder;
      break;
    case "חשבונית להמשך טיפול":
    case "REQUIRES_ATTENTION":
      backgroundColor = "#FFF3E0";
      color = "#E65100";
      borderColor = "#FFB74D";
      break;
    case "חשבונית ריטיינר - ממתין לשיוך הזמנות":
    case "pending_retainer_allocation":
      backgroundColor = softColors.retainerBg;
      color = softColors.retainer;
      borderColor = softColors.retainerBorder;
      break;
    case "ממתין לבירור":
    case "pending_clarification":
      backgroundColor = "#F3E5F5";
      color = "#7B1FA2";
      borderColor = "#CE93D8";
      break;
    case "שגיאה בפריוריטי":
    case "priority_creation_failed":
    case "יצירה בפריוריטי נכשלה":
      backgroundColor = softColors.errorBg;
      color = softColors.error;
      borderColor = softColors.errorBorder;
      break;
    default:
      backgroundColor = softColors.infoBg;
      color = softColors.info;
      borderColor = softColors.infoBorder;
  }

  return {
    backgroundColor,
    color,
    border: '1px solid',
    borderColor
  };
};

export const activeStatusStyles = {
  active: {
    color: '#059669', 
    fontWeight: '500'
  },
  inactive: {
    color: '#9CA3AF', 
    fontWeight: '400'
  }
};